import { CSSProperties } from 'react';

export const BOTTOM_MENU_HEIGHT = 56;

export const bottomMenuNumberedNotifStyles: CSSProperties = {
  top: -8,
  right: -16,
};
